import React from 'react';
import Servicesbanner from '../Servicesbanner';
import Aboutservices from '../Aboutservices';
import Aboutregistered from '../Aboutregistered';
import Aboutwhychoose from '../Aboutwhychoose';
import Aboutbox from '../Aboutbox';
import Testimonials from '../Testimonials';

const About = () => {
  return (
    <>
      <Servicesbanner 
        title="About" 
        highlight="Us" 
      />
      <Aboutservices />
      <Aboutregistered />
      <Aboutwhychoose />
      <Aboutbox />
      <Testimonials />
    </>
  )
}

export default About